/**
 * Inyecta la marca activa en el submit de los formularios de búsqueda.
 *
 * Los forms de búsqueda apuntan a /search (GET), una página neutral donde
 * brand-mode.liquid resuelve 'main' salvo que la URL traiga ?view_brand=.
 * Liquid no puede leer la cookie view_brand; la marca activa solo vive en
 * html[data-brand-mode] (la estampa el script inline de <head>). Sin este
 * input, un usuario en ToskaniMed que busca aterriza en /search resuelto
 * como Main y ve resultados Main (el filtro server-side de search.liquid
 * depende de brand_mode). Inyectamos view_brand en el form antes de que el
 * navegador lo serialice, para que /search respete la marca de origen.
 *
 * Mismo criterio que wim-related-products.js (la marca no viaja sola en una
 * request a página neutral). Este script es la fuente de verdad de view_brand
 * en los submits de búsqueda: si un form trajera el suyo, se sobreescribe con
 * la marca activa de html[data-brand-mode].
 */
(() => {
  'use strict';

  const SEARCH_INPUT_SELECTOR = 'input[name="q"]';
  const BRAND_PARAM = 'view_brand';

  /**
   * Lee el brand_mode desde el atributo que el script inline de
   * layout/theme.liquid fija en <html> antes del primer paint.
   * Fallback a 'main' si aún no está disponible o es inválido.
   *
   * @returns {string} 'main' o 'med'.
   */
  const getBrandMode = () => {
    const mode = document.documentElement.getAttribute('data-brand-mode');
    return mode === 'med' ? 'med' : 'main';
  };

  /**
   * Inyecta o actualiza el input oculto view_brand dentro de un form.
   * Idempotente: si ya existe, solo refresca su value (no duplica nodos).
   * No toca ningún otro input (preserva los filter.p.* de Search & Discovery).
   *
   * @param {HTMLFormElement} form - Form de búsqueda.
   * @param {string} brandMode - Marca activa a inyectar.
   */
  const injectBrandParam = (form, brandMode) => {
    let field = form.querySelector(`input[name="${BRAND_PARAM}"]`);
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = BRAND_PARAM;
      form.appendChild(field);
    }
    field.value = brandMode;
  };

  // Listener delegado en captura: garantiza que la inyección ocurre antes de
  // que el navegador serialice el form, sin depender de listeners por-form
  // (cubre forms presentes y futuros, incluidos los del Section Rendering API).
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      // input[name="q"] es la señal fiable de form de búsqueda.
      if (!form.querySelector(SEARCH_INPUT_SELECTOR)) return;
      injectBrandParam(form, getBrandMode());
    },
    true
  );
})();
